import React from 'react';
const DirectionContext = React.createContext('ltr');
export default DirectionContext;
//# sourceMappingURL=direction.js.map